// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__NBZjY","hero_sec":"Hero_hero_sec__XLYtZ","hero_screen_height":"Hero_hero_screen_height__sEdOt"};